const sides = 1;
export class LineDrawer {
    draw(data) {
        const { context, particle, radius } = data, shapeData = particle.shapeData, centerY = 0;
        context.moveTo(-radius, centerY);
        context.lineTo(radius, centerY);
        context.lineCap = shapeData?.cap ?? "butt";
    }
    getSidesCount() {
        return sides;
    }
}
